import { NuxtAppOptions } from '@nuxt/types'
import { Capacitor } from '@capacitor/core'
import { version } from '../package.json'

const getDeviceHeader = (isNativePlatform: boolean, isMobile: boolean) => {
  if (isNativePlatform) return 'mobileapp'
  return isMobile ? 'mobile' : 'desktop'
}

const getHostHeader = (app: NuxtAppOptions, store: NuxtAppOptions['store']) => {
  return app.context?.req?.headers.host || store?.state?.site?.host
}

export default function ({
  $axios,
  $device,
  store,
  app,
  $config: { baseURL },
}: NuxtAppOptions) {
  $axios.defaults.baseURL = baseURL

  $axios.defaults.headers.common.Device = getDeviceHeader(
    Capacitor.isNativePlatform(),
    $device.isMobile
  )
  $axios.defaults.headers.common['X-API-Version'] = version

  const host = getHostHeader(app, store)
  if (host) {
    $axios.defaults.headers.common['X-Host'] = host
  }
}
